var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8CC7\u7522 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1-2",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.1,172.2v71.1a3.16,3.16,0,0,1-3.2,3.2H257.5a3.31,3.31,0,0,1-2.6-1.3l-32.6-44v42.2a3.16,3.16,0,0,1-3.2,3.2H207.7a3.16,3.16,0,0,1-3.2-3.2V172.3a3.16,3.16,0,0,1,3.2-3.2H219a3,3,0,0,1,2.6,1.4l32.6,44V172.3a3.16,3.16,0,0,1,3.2-3.2h11.4a3.16,3.16,0,0,1,3.3,3.1Zm-82-3.2H178.7a3.16,3.16,0,0,0-3.2,3.2v71.1a3.16,3.16,0,0,0,3.2,3.2h11.4a3.16,3.16,0,0,0,3.2-3.2V172.2a3.22,3.22,0,0,0-3.2-3.2Zm-27.5,59.6H131.5V172.2a3.16,3.16,0,0,0-3.2-3.2H116.9a3.16,3.16,0,0,0-3.2,3.2v71.1a2.94,2.94,0,0,0,.9,2.2,3.37,3.37,0,0,0,2.2.9h45.7a3.16,3.16,0,0,0,3.2-3.2V231.8a3.2,3.2,0,0,0-3.1-3.2ZM332.1,169H286.4a3.22,3.22,0,0,0-3.2,3.2v71.1a3.22,3.22,0,0,0,3.2,3.2h45.7a3.16,3.16,0,0,0,3.2-3.2V231.9a3.16,3.16,0,0,0-3.2-3.2H301v-12h31.1a3.16,3.16,0,0,0,3.2-3.2V202a3.16,3.16,0,0,0-3.2-3.2H301v-12h31.1a3.16,3.16,0,0,0,3.2-3.2V172.2a3.36,3.36,0,0,0-3.2-3.2ZM448,81.7V367c-.1,44.8-36.8,81.1-81.7,81H81c-44.8-.1-81.1-36.9-81-81.7V81C.1,36.2,36.9-.1,81.7,0H367C411.8.1,448.1,36.8,448,81.7ZM386.4,204.3c0-73-73.2-132.4-163.1-132.4S60.2,131.3,60.2,204.3c0,65.4,58,120.2,136.4,130.6,19.1,4.1,16.9,11.1,12.6,36.8-.7,4.1-3.3,16.1,14.1,8.8s93.9-55.3,128.2-94.7C375.1,259.8,386.4,233.5,386.4,204.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.f392c2bda55bc38aee7a735bc29342dc.svg";
export { ForwardRef as ReactComponent };